export const documentTemplateConstants = {
  SAVING_NEW_DOCUMENT_TEMPLATE: 'SAVING_NEW_DOCUMENT_TEMPLATE',
  SAVING_NEW_DOCUMENT_TEMPLATE_SUCCESS: 'SAVING_NEW_DOCUMENT_TEMPLATE_SUCCESS',
  SAVING_NEW_DOCUMENT_TEMPLATE_ERROR: 'SAVING_NEW_DOCUMENT_TEMPLATE_ERROR',

  UPDATE_DOCUMENT_TEMPLATE: 'UPDATE_DOCUMENT_TEMPLATE',
  UPDATE_DOCUMENT_TEMPLATE_SUCCESS: 'UPDATE_DOCUMENT_TEMPLATE_SUCCESS',
  UPDATE_DOCUMENT_TEMPLATE_ERROR: 'UPDATE_DOCUMENT_TEMPLATE_ERROR',

  FETCH_DOCUMENT_TEMPLATES_FOR_USER: 'FETCH_DOCUMENT_TEMPLATES_FOR_USER',
  FETCH_DOCUMENT_TEMPLATES_FOR_USER_SUCCESS: 'FETCH_DOCUMENT_TEMPLATES_FOR_USER_SUCCESS',
  FETCH_DOCUMENT_TEMPLATES_FOR_USER_ERROR: 'FETCH_DOCUMENT_TEMPLATES_FOR_USER_ERROR',

  FETCH_DOCUMENT_TEMPLATES_FOR_CLIENT: 'FETCH_DOCUMENT_TEMPLATES_FOR_CLIENT',
  FETCH_DOCUMENT_TEMPLATES_FOR_CLIENT_SUCCESS: 'FETCH_DOCUMENT_TEMPLATES_FOR_CLIENT_SUCCESS',
  FETCH_DOCUMENT_TEMPLATES_FOR_CLIENT_ERROR: 'FETCH_DOCUMENT_TEMPLATES_FOR_CLIENT_ERROR',

  FETCH_DOCUMENT_TEMPLATES_FOR_BOAT: 'FETCH_DOCUMENT_TEMPLATES_FOR_BOAT',
  FETCH_DOCUMENT_TEMPLATES_FOR_BOAT_SUCCESS: 'FETCH_DOCUMENT_TEMPLATES_FOR_BOAT_SUCCESS',
  FETCH_DOCUMENT_TEMPLATES_FOR_BOAT_ERROR: 'FETCH_DOCUMENT_TEMPLATES_FOR_BOAT_ERROR',

  ADDING_FILE_TO_DOCUMENT: 'ADDING_FILE_TO_DOCUMENT',
  ADDING_FILE_TO_DOCUMENT_SUCCESS: 'ADDING_FILE_TO_DOCUMENT_SUCCESS',
  ADDING_FILE_TO_DOCUMENT_ERROR: 'ADDING_FILE_TO_DOCUMENT_ERROR',

  ADD_DOCUMENT_TEMPLATE_TO_BOAT_LOADING: 'ADD_DOCUMENT_TEMPLATE_TO_BOAT_LOADING',
  ADD_DOCUMENT_TEMPLATE_TO_BOAT_SUCCESS: 'ADD_DOCUMENT_TEMPLATE_TO_BOAT_SUCCESS',
  ADD_DOCUMENT_TEMPLATE_TO_BOAT_ERROR: 'ADD_DOCUMENT_TEMPLATE_TO_BOAT_ERROR',
} as const
